import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

/* eslint-disable eslint-comments/disable-enable-pair */

/* eslint-disable require-atomic-updates */

/* eslint-disable no-param-reassign */

/* eslint-disable @typescript-eslint/typedef */
import compose from 'koa-compose';
import combineParamsMiddleware from "./middleware/combineParams";
import optionsParserMiddleware from "./middleware/optionsParser";

var Http = /*#__PURE__*/function () {
  function Http(parent, fetch) {
    _classCallCheck(this, Http);

    _defineProperty(this, "get", this.wrap('GET'));

    _defineProperty(this, "put", this.wrap('PUT'));

    _defineProperty(this, "post", this.wrap('POST'));

    _defineProperty(this, "patch", this.wrap('PATCH'));

    _defineProperty(this, "delete", this.wrap('DELETE'));

    _defineProperty(this, "_middleware", []);

    _defineProperty(this, "parent", void 0);

    _defineProperty(this, "fetch", void 0);

    if (parent instanceof Http) {
      this.parent = parent;
    } else if (fetch === undefined && typeof parent === 'function') {
      this.fetch = parent;
    } else if (fetch) {
      this.fetch = fetch;
    }
  }

  _createClass(Http, [{
    key: "middleware",
    get: function get() {
      if (this.parent) {
        return [].concat(_toConsumableArray(this.parent.middleware), _toConsumableArray(this._middleware));
      } else {
        return _toConsumableArray(this._middleware);
      }
    }
  }, {
    key: "useMiddleware",
    value: function useMiddleware(callback) {
      this._middleware.push(callback);
    }
  }, {
    key: "child",
    value: function child(fetch) {
      return new Http(this, fetch || this.fetch);
    }
  }, {
    key: "request",
    value: function () {
      var _request = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(url, options) {
        var _this = this;

        var m, middlewareFn, ctx, result;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (typeof url === 'string') {
                  if (options) {
                    options.url = url;
                  } else {
                    options = {
                      url: url
                    };
                  }
                } else {
                  options = url;
                }

                url = options.url || '';
                options.headers = options.headers || {};
                m = [].concat(_toConsumableArray(this.middleware), [optionsParserMiddleware, combineParamsMiddleware, /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(ctx, next) {
                    var req, res;
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            req = ctx.req;
                            _context.next = 3;
                            return (_this.fetch || fetch)(ctx.url, req);

                          case 3:
                            res = _context.sent;
                            ctx.res = res;
                            _context.next = 7;
                            return next();

                          case 7:
                            return _context.abrupt("return", _context.sent);

                          case 8:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x3, _x4) {
                    return _ref.apply(this, arguments);
                  };
                }()]);
                middlewareFn = compose(m);
                ctx = {
                  url: url,
                  req: options,
                  res: {}
                };
                _context2.next = 8;
                return middlewareFn(ctx);

              case 8:
                result = _context2.sent;
                return _context2.abrupt("return", result === undefined ? ctx.res : result);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function request(_x, _x2) {
        return _request.apply(this, arguments);
      }

      return request;
    }()
  }, {
    key: "wrap",
    value: function wrap(method) {
      var _this2 = this;

      return function (url) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (typeof url === 'string') {
          options.url = url;
        } else {
          options = url;
        }

        options.method = method;
        return _this2.request(options);
      };
    }
  }]);

  return Http;
}();

export { Http as default };
//# sourceMappingURL=Http.js.map